import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function(value) {
  return moment(value).format('YYYY-MM-DD HH:mm:ss')
})

Vue.filter('dateTime', function(value) {
  return moment(value).format('YYYY-MM-DD HH:mm')
})

Vue.filter('dateWithYear', function(value) {
  return moment(value).format('YYYY-MM-DD')
})

Vue.filter('dateWithoutYear', function(value) {
  return moment(value).format('MM-DD')
})

Vue.filter('time', function(value) {
  return moment(value).format('HH:mm')
})

export default moment